import { controls,grouped } from "../controls";
const cnb_observation_types = {
label: "Cnb Observation Types",
pageLabel: "Cnb Observation Types",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
bulk:{columns:["cnb_observation_type_code","cnb_observation_type_display"] },
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label:"Bulk",uid:"bulk"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "cnb_observation_type_code",maxlength:15}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "cnb_observation_type_display",width:"col-sm-4",maxlength:100}),
...controls.checkBox({ tab: "filter",default:true, label: "Active", name: "cnb_observation_type_active" }),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "cnb_observation_type_code",isRequired:true,maxlength:15}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Description",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "cnb_observation_type_display",isRequired:true,width:"col-sm-4",maxlength:100}),
]
,history:{
perPage: 10,
reportHeader: "Cnb Observation Types",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Cnb Observation Type Code",accessor: "cnb_observation_type_code",},
{Header: "Cnb Observation Type",accessor: "cnb_observation_type_display",},
{Header: "Cnb Observation Type Active",accessor: "cnb_observation_type_active",type:'tick'},
]}};
export default cnb_observation_types;